<template>
  <div>
    <o-base-justify-text>
      <span v-html="getTexto('scoring.resultado', codigoPromocion) || $t('reservas.scoring.aContinuacion')"/>
    </o-base-justify-text>
    <v-layout >
        <v-flex xs12>
          <v-card >
            <v-container fluid>
              <o-medium-title>
                {{$t('reservas.scoring.resumen')}}
              </o-medium-title>
              <v-layout justify-center align-center pt-3 :column="$vuetify.breakpoint.xsOnly">
                <v-flex xs12 md4 lg4 xl4 :class="$vuetify.breakpoint.xsOnly ? 'mb-4' : ''">
                  <v-layout justify-center align-center>
                    <v-icon style="font-size: 80px" color="primary" class="custom-icon">
                      icon-proveedores
                    </v-icon>
                    <v-flex xs6 md8 lg7 pl-2>
                        {{$t('reservas.scoring.numPersonas')}}
                      <h1 class="primary--text">{{ getCompradores }}</h1>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md4 lg4 xl4 :class="$vuetify.breakpoint.xsOnly ? 'mb-4' : ''">
                  <v-layout justify-center align-center>
                    <v-icon style="font-size: 80px" color="primary" class="custom-icon">
                      icon-piggy-bank
                    </v-icon>
                    <v-flex xs6 md8 lg8 pl-2>
                        {{$t('reservas.scoring.totalIngresos')}}
                      <h1 class="primary--text">{{ getIngresos | currency}}</h1>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md4 lg4 xl4>
                  <v-layout justify-center align-center>
                    <v-icon style="font-size: 80px" color="primary" class="custom-icon">
                      icon-icono-gastos
                    </v-icon>
                    <v-flex xs6 md8 lg8 pl-2>
                        {{$t('reservas.scoring.totalGastos')}}
                      <h1 class="primary--text">{{ getGastos | currency }}</h1>
                    </v-flex>      
                  </v-layout>
                </v-flex>
              </v-layout>
              <o-base-justify-text class="mt-5">
                <v-flex>
                  {{$t('reservas.scoring.alquilerMax')}} <b> {{ alquilerMaximo | currency }} </b>.
                </v-flex>
              </o-base-justify-text>
              <o-base-justify-text>
                <i18n path="reservas.scoring.resultado" tag="v-flex">
                  <template #inmueble>{{inmuebleDescripcion}}</template>
                  <template #promo>{{promocionDescripcion}}</template>
                  <template #importe>
                    <b>{{ precioAlquiler | currency }}</b>
                  </template>
                  <template #apto>
                    <b class="scoringValido primary--text">
                      {{ scoringValido ? $t('reservas.scoring.apto') : $t('reservas.scoring.noApto') }}
                    </b>
                  </template>
                </i18n>
              </o-base-justify-text>
            </v-container>
        </v-card>
        <v-layout justify-center align-center :column="$vuetify.breakpoint.smAndDown" 
            :shrink="$vuetify.breakpoint.smAndDown" mt-5>
          <!-- <v-btn 
            large
            color="primary"
            @click="abandonar"
          >
            ABANDONAR
          </v-btn> -->
          <v-btn
            v-if="scoringValido"
            large
            :loading="waitingForLoad"
            :disaled="waitingForLoad"
            color="primary"
            @click="terminarScoring()"
          >
            {{$t('reservas.scoring.continuar')}}
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import rules from '@/mixins/rules'

export default {
  mixins: [rules],
  data () {
    return {
      waitingForLoad: false,
      compradores: []
    }
  },
  mounted () {
    if (!this.scoringValido) {
      // eslint-disable-next-line
      window.parent.postMessage('scoring_fallido', '*')
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      codigoPromocion: 'incrustado/codigoPromocion',
      codigoActivo: 'incrustado/codigoActivo',
      getScoring: 'scoring/get'
    }),
    scoringDatos () {
      let aux = this.getScoring.map(x => {
        return {
          ...x,
          numeroPersonas: x.compradores.length,
          ingresos: x.Math.round(this.getScoring.totalIngresos * 100) / 100,
          gastos: x.Math.round(this.getScoring.totalGastos * 100) / 100,
          alquilerMax: x.Math.round(this.getScoring.alquilerMaximo * 100) / 100,
          inmuebleDesc: x.inmueble.descripcionLarga,
          promoDesc: x.promocion.descripcion,
          precioAlq: x.precioAlquiler,
          scoringVali: x.scoringValido
        }
      })
      return aux
    },
    getCompradores () {
      return this.getScoring.compradores.length
    },
    getIngresos () {
      return Math.round(this.getScoring.totalIngresos * 100) / 100
    },
    getGastos () {
      return Math.round(this.getScoring.totalGastos * 100) / 100
    },
    alquilerMaximo () {
      return Math.round(this.getScoring.alquilerMaximo * 100) / 100
    },
    inmuebleDescripcion () {
      return this.getScoring.inmueble.descripcionLarga
    },
    promocionDescripcion () {
      return this.getScoring.promocion.descripcion
    },
    precioAlquiler () {
      return this.getScoring.precioAlquiler
    },
    scoringValido () {
      return this.getScoring.scoringValido
    }
  },
  methods: {
    terminarScoring () {
      this.waitingForLoad = true
      this.$emit('terminado')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .textoPromo 
    font-size: 16px !important;
    font-weight: 400;

  .scoringValido
    font-size: 20px

  .alquilerMaximo
    font-size: 50px
</style>



// WEBPACK FOOTER //
// src/components/reservas/scoring/ResultadoScoring.vue